export const normalizeSearchText = value => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim()

export const hasAdministrationQueueAccess = userSession => (
  userSession?.user?.userrole || []
).some(userRole => Number(userRole?.role?.roletype) === 0)

export const shouldShowAdministrationQueueBadge = count => Number(count) > 0

export const getCustomerName = chat => (
  chat?.customer?.name
  || chat?.customername
  || chat?.sendername
  || ''
)

export const matchesConversationText = (chat, searchTerm) => {
  const term = normalizeSearchText(searchTerm)
  if (!term) return true

  const customerMatches = normalizeSearchText(getCustomerName(chat)).includes(term)
  const tagMatches = Array.isArray(chat?.chattags) && chat.chattags.some(chatTag =>
    normalizeSearchText(chatTag?.tag?.name).includes(term)
  )

  return customerMatches || tagMatches
}

export const filterWithoutChannelGroups = (groups, searchTerm) => {
  const term = normalizeSearchText(searchTerm)
  if (!term) return groups || []

  return (groups || []).reduce((filteredGroups, group) => {
    const chats = (group.chats || []).filter(chat =>
      normalizeSearchText(getCustomerName(chat)).includes(term)
    )

    if (chats.length > 0) filteredGroups.push({ ...group, chats })
    return filteredGroups
  }, [])
}

export const filterTeamMismatchGroups = (groups, searchTerm) => {
  const term = normalizeSearchText(searchTerm)
  if (!term) return groups || []

  return (groups || []).reduce((filteredGroups, group) => {
    const chats = (group.chats || []).filter(chat =>
      normalizeSearchText(getCustomerName(chat)).includes(term)
    )

    if (chats.length > 0) filteredGroups.push({ ...group, chats })
    return filteredGroups
  }, [])
}
